import React from "react";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getIndIntersted = async (queryParams) => {
    try {
  return await get<ApiResponse<[]>>(`/indinterested?${queryParams}`).then((res)=> {
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){
    HandleApiError(e)
}
};
